module.exports = __webpack_public_path__ + "static/img/94.1477eeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/94.png
// module id = HeWr
// module chunks = 0